// Figures that update on their own (Lane 1393, Ryan's 2026-10-06 test): when new offers
// or a rule change make a scenario out of date, the screen asks for the calculation
// itself, so the buyer never has to click Recalculate. It is the same request as the
// Recalculate button ("evaluate": it changes no rule, so an open chat card stays valid),
// and the server returns the waiting job instead of a second one.
//
// items: [{ scenario_id, key }], memoized by the caller. `key` names one answer to ask
// for (the scenario and the result it replaces): each key is asked for once while the
// screen is open, so a calculation that fails is never asked for again in a loop.
import { useEffect, useRef } from 'react';

export default function useAutoRecalculate(api, eventId, items, onQueued) {
  const tried = useRef(new Set());
  useEffect(() => {
    const due = (items || []).filter((x) => x && x.scenario_id && x.key && !tried.current.has(x.key));
    if (due.length === 0) return;
    due.forEach((x) => tried.current.add(x.key));
    // Always read again after the requests, even when the items changed meanwhile:
    // each key is asked for once, so this reload is the one that shows "Calculating".
    Promise.all(due.map((x) => api.scenarioAction(eventId, 'evaluate', { scenario_id: x.scenario_id })
      .catch(() => null)))
      .then(() => { if (onQueued) onQueued(); });
  }, [api, eventId, items, onQueued]);
}
